export const qualities = [
  "Compromiso",
  "Responsabilidad",
  "Constancia",
  "Autodidacta",
  "Trabajo en equipo",
];
